import OrderFlowRefresh from './OrderFlowRefresh';
import BasicMenu from '../../../../../../components/BasicMenu';
import PeriodSettings from './PeriodSettings';

export default function FilterOptions() {
  return (
    <BasicMenu direction="vert">
      <PeriodSettings />
      <OrderFlowRefresh />
    </BasicMenu>
  );
}
